/**
 * Room code helpers, mirroring the server's alphabet so a typo is caught before
 * a round trip. The server validates again — this is only for the input field.
 */

const ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const ROOM_CODE_LENGTH = 6;

export function normalizeRoomCode(input: string): string {
  return input.trim().toUpperCase();
}

export function isValidRoomCode(input: string): boolean {
  const code = normalizeRoomCode(input);
  return code.length === ROOM_CODE_LENGTH && [...code].every((char) => ALPHABET.includes(char));
}
